interface specialtyFile {
    file_pos: number,
    file_id: number,
    specialty_id: number,
    file_name: string,
    file_description: string,
    file_type: string,
    file_size: number,
    file_path: string
    upload_time: string
    file_content: Blob,
    file_url: string,
    download_url: string,
    file: File
}


interface Specialty {
    specialty_id: number,
    name: string,
    files: specialtyFile[]
}

const specialtiesResetState = () => ({
    specialties: [] as Specialty[],
    showingSpecialtyData: false
});

export const specialties = {
    state: specialtiesResetState(),
    mutations: {
        setSpecialties(state: any, specialties: Specialty[]) {
            state.specialties = specialties
        },
        setShowingSpecialtyData(state: any, showingSpecialtyData: boolean) {
            state.showingSpecialtyData = showingSpecialtyData
        },
    },
    getters: {
        getSpecialties(state: any): Specialty[] {
            return state.specialties
        },
        getShowingSpecialtyData(state: any): boolean {
            return (state.showingSpecialtyData)
        }
    },
    actions: {
        fetchSpecialties(state: any) {
            return new Promise((resolve, reject) => {
                fetch(process.env.BASE_URL + `api/specialties/`,
                    {
                        method: 'GET',
                        headers:
                        {
                            Authorization: `Bearer ${state.getters.token}`,
                        }
                    })
                    .then(res => res.json())
                    .then(specialties => {
                        state.commit('setSpecialties', specialties)
                        resolve(specialties)
                    })
                    .catch(err => reject(err))
            })
        },

        async createSpecialty(state: any, newSpecialty: Specialty) {
            const response = await fetch(process.env.BASE_URL + `api/specialties`,
                {
                    method: 'POST',
                    headers:
                    {
                        Authorization: `Bearer ${state.getters.token}`,
                    },
                    body: JSON.stringify(newSpecialty)

            })

            if (response.ok) {
                const responseData = await response.json(); // <-- parse the JSON response
                const specialtyId = responseData.specialty_id; // <-- extract the ID
                state.dispatch("fetchSpecialties")
                return specialtyId
            } else {
                throw new Error('error_creating_new_specialty')
            }
        },

        

        async deleteSpecialty(state: any, specialty: Specialty) {
            const response = await fetch(process.env.BASE_URL + `api/specialties/${specialty.specialty_id}`, {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${state.getters.token}`,
                }
            })

            if (response.ok) {
                state.dispatch("fetchSpecialties")
                return true;
            } else {
                throw new Error('error_removing_specialty')
            }
        },

        toggleShowingSpecialtyData(state: any, showingSpecialtyData: boolean) {
            console.log("toggleShowingSpecialtyData")
            state.commit('setShowingSpecialtyData', !showingSpecialtyData)
        },
    }
}

const specialtyResetState = () => ({
    editedSpecialtyData: {
        specialty_id: 0,
        name: '',
    },
    specialtyFiles: [] as specialtyFile[],
    newSpecialtyFileData:
    {
        file_pos: 0,
        file_id: 0,
        specialty_id: 0,
        file_name: '',
        file_description: '',
        file_type: '',
        file_size: '',
        file_path: '',
        file_content: new Blob([], { type: 'application/octet-stream' }),
        file_url: "",
        download_url: "",
        file: null
    },
    editingSpecialty: false,
    specialtyFileIdsToBeDeleted: [] as number[],
});

export const editedSpecialty = {
    state: specialtyResetState(),
    getters: {
        getEditedSpecialtyData(state: any): Specialty {
            return (state.editedSpecialtyData)
        },

        getEditedSpecialtyFiles(state: any): specialtyFile[] {
            return (state.specialtyFiles || [])
        },

        getEditedSpecialtyNewFileData(state: any): specialtyFile {
            return (state.newSpecialtyFileData)
        },

        getEditedSpecialtyFilesToDelete(state: any): number[] {
            return (state.specialtyFileIdsToBeDeleted)
        },
        
        getEditingSpecialty(state: any): boolean {
            return (state.editingSpecialty)
        }
    },
    mutations: {

        setEditedSpecialtyData(state: any, editedSpecialtyData: any) {
            console.log("setEditedSpecialtyData", editedSpecialtyData);
            state.editedSpecialtyData.specialty_id = editedSpecialtyData.specialty_id;
            state.editedSpecialtyData.name = editedSpecialtyData.name;
        },

        setEditedSpecialtyFilesData(state: any, editedSpecialtyFilesData: any) {
            console.log("setEditedSpecialtyFilesData");
            console.log(editedSpecialtyFilesData);

            state.specialtyFiles = [];

            // Process each file
            editedSpecialtyFilesData.forEach((file: any, index: number) => {
                file.file_pos = index;
                console.log(file);
                // Ensure download_url is set
                file.download_url = file.download_url || `/api/specialties/download-file.php?file_id=${file.file_id}`;
                state.specialtyFiles.push(file);
            });
            
        },

        setEditedSpecialtyAddFile(state: any, newFile: any) {
            newFile.file_pos = state.specialtyFiles.length
            state.specialtyFiles.push(newFile)
        },

        setEditedSpecialtyRemoveFile(state: any, file_pos: number) {
            console.log("setEditedSpecialtyRemoveFile")
            state.specialtyFiles.splice(file_pos, 1)
            state.specialtyFiles.forEach((file: any, index: number) => {
                file.file_pos = index;
            })
        },

        setEditedSpecialtyIniFile(state: any) {
            state.newSpecialtyFileData = {
                file_pos: 0,
                file_id: 0,
                specialty_id: 0,
                file_name: '',
                file_description: '',
                file_type: '',
                file_size: '',
                file_path: '',
                upload_time : '',
                file: null
            }
        },

        setEditedSpecialtyFileNewData(state: any, newFile: File) {
            state.newSpecialtyFileData.file_name = newFile.name
            state.newSpecialtyFileData.file_type = newFile.type
            state.newSpecialtyFileData.file_size = newFile.size
            state.newSpecialtyFileData.file = newFile
        },

        setEditingSpecialty(state: any, editingSpecialty: boolean) {
            state.editingSpecialty = editingSpecialty
        },

        setEditedSpecialtyFilesToDelete(state: any, FileIdsToDelete: number[]) {
            state.specialtyFileIdsToBeDeleted = FileIdsToDelete
        },

        setEditedSpecialtyAddFileIdToDelete(state: any, fileId: number) {
            state.specialtyFileIdsToBeDeleted.push(fileId)
        },
        
        specialtyResetStateMut(state: any) {
            Object.assign(state, specialtyResetState())
        }
    },
        
    actions: {

        addFileEditedSpecialty(state: any, newFile: specialtyFile) {

            newFile.file_id = 0
            console.log(newFile)
            state.commit('setEditedSpecialtyAddFile', newFile)

        },

        saveSpecialtyFileToBeDeleted(state: any, fileId: number) {
            console.log(fileId)
            state.commit('setEditedSpecialtyAddFileIdToDelete', fileId)
        },

        removeFileEditedSpecialty(state: any, file_pos: number) {
            console.log(file_pos)
            state.commit('setEditedSpecialtyRemoveFile', file_pos)
        },

        iniEditedSpecialtyNewFile(state: any) {
            state.commit('setEditedSpecialtyIniFile')
        },

        updateNewSpecialtyFileData(state: any, selectedFile: File)
        {
            state.commit('setEditedSpecialtyFileNewData', selectedFile)
            
        },

        async iniEditedSpecialty(state: any, specialtyId: number) {

            console.log("iniEditedSpecialty", specialtyId);

            return (new Promise((resolve, reject) => {
                fetch(process.env.BASE_URL + `api/specialties/byid/` + specialtyId.toString(),
                    {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${state.getters.token}`,
                        }
                    })
                    .then((res) => res.json())
                    .then((specialty_data) => {
                        console.log(specialty_data);
                        console.log(specialty_data.specialty_id);
                        state.commit('setEditedSpecialtyData', specialty_data)
                        console.log(specialty_data.name);
                        resolve(specialty_data)
                    })
                    .catch(err => reject(err))
            }))

        },

        async iniEditedSpecialtyFiles(state: any, specialtyId: number) {

            console.log("iniEditedSpecialtyFiles");
            console.log(specialtyId);
            console.log(process.env.BASE_URL + `api/specialties/files/` + specialtyId.toString());
            

            return (new Promise((resolve, reject) => {
                fetch(process.env.BASE_URL + `api/specialties/files/` + specialtyId.toString(),
                    {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${state.getters.token}`,
                        }
                    })
                    .then(async (res) => {
                        if (!res.ok) {
                            throw new Error(`HTTP error! Status: ${res.status}`);
                        }
                        return res.json();
                    })
                    .then((specialtyFilesData) => {
                        console.log("Received specialty files:", specialtyFilesData);
                        
                        // Store the data in Vuex
                        state.commit('setEditedSpecialtyFilesData', specialtyFilesData);
                        resolve(specialtyFilesData);
                    })
                    .catch(err => {
                        console.error("Error fetching specialty files:", err);
                        reject(err);
                    });
            }))

        },

        iniSpecialtyDetailing(state: any, specialtyData: any) {

            console.log("iniSpecialtyDetailing: ", specialtyData);

            console.log(specialtyData);
            console.log(specialtyData.specialty_id);
            state.commit('setEditedSpecialtyData', specialtyData)
        },

        iniSpecialtyEditing(state: any) {

            state.commit('setEditingSpecialty', true);
        },

        endSpecialtyEditing(state: any) {

            state.commit('setEditingSpecialty', false);
            state.commit('setEditedSpecialtyFilesToDelete', [])
        
        },

        async createEditedSpecialtyFile(state: any, newFileData: any) {
            const specialtyId = JSON.parse(newFileData.get('file_data')).specialty_id
            console.log(JSON.stringify(newFileData))
            const response = await fetch(process.env.BASE_URL + `api/specialties/file/` + specialtyId.toString(), {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${state.getters.token}`,
                },
                body: newFileData
            })
            if (!response.ok) {
                throw new Error('error_creating_new_file')
            }
        },

        async deleteEditedSpecialtyFile(state: any, fileId: number) {
            console.log(fileId)
            const response = await fetch(process.env.BASE_URL + `api/specialties/file/` + fileId.toString(), {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${state.getters.token}`,
                }
            })
            if (!response.ok) {
                throw new Error('error_deleting_file')
            }
        },

        async editSpecialty(state: any, editedSpecialtyData: Specialty) {
            console.log(JSON.stringify(editedSpecialtyData))
            const response = await fetch(process.env.BASE_URL + `api/specialties/` + editedSpecialtyData.specialty_id.toString(), {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${state.getters.token}`,
                },
                body: JSON.stringify(editedSpecialtyData),
            })

            var editedSpecialtyId: number = 0

            if (response.ok) {
                const resjson = await response.json()
                editedSpecialtyId = resjson.specialty_id

            } else {
                throw new Error('error_updating_specialty')
            }
            return (editedSpecialtyId)
        },

        resetSpecialtyFiles(state: any) {
            state.commit('setEditedSpecialtyFilesData', [])
        }


    }
}

